var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0013 13.333V18.833",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0013 26.1667C20.0138 26.1667 20.8346 25.3459 20.8346 24.3333C20.8346 23.3208 20.0138 22.5 19.0013 22.5C17.9888 22.5 17.168 23.3208 17.168 24.3333C17.168 25.3459 17.9888 26.1667 19.0013 26.1667Z",
    fill: "#4EAEA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1394 1.96529C18.526 1.30798 19.4766 1.30798 19.8632 1.96529L36.4481 30.1596C36.8403 30.8263 36.3596 31.6667 35.5862 31.6667H2.41639C1.64297 31.6667 1.16231 30.8263 1.55445 30.1596L18.1394 1.96529Z",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.5e87f383.svg";
export { ForwardRef as ReactComponent };